export default __webpack_public_path__ + "static/media/Air.7743021b.gif";